import React, { useRef } from 'react'
import { Link } from 'react-router-dom';
import './blog.css';
import {BsFacebook, BsDiscord} from 'react-icons/bs'
import {RiInstagramFill} from 'react-icons/ri'

//import reportWebVitals from './reportWebVitals';

const Event = () => {
  const ref = useRef(null);

  return (
    <div>
      <div className='blog__container'>
        <div className="row">
          <div className="first-column">
            <header>
              <h3 className="site-post-title rounded title-padding">
                <b>RSVP for WiC Events</b>
              </h3>
            </header>
             <section className="words">
             <p>WiC is dedicated to providing informative and fun social events in the Allen School community. 
             Such events include company networking sessions, research panels, community-building, tech talks,
             diversity discussions, Winter Affiliates Dinner, and high school outreach initiatives.</p>
            </section>
            <div>
            <iframe src="https://calendar.google.com/calendar/embed?src=c_3423dc6c3b21093205d5499dbec536989ce0379a61786813c69018a5cc5e7b6a%40group.calendar.google.com&ctz=America%2FLos_Angeles" width="800" height="600" frameborder="0" scrolling="no"></iframe>
            </div>
          </div> 
        </div>
    </div>

      <div className='actions' ref={ref}>
      <div className='action-description'>
          <p ><strong>Not a  WiC member?</strong></p>
          <p>Join <a href='http://tinyurl.com/wic-membership-form' target='_blank' class='footerLink'>here</a> and sign up for 
          our <a href='https://mailman.cs.washington.edu/mailman/listinfo/wic' target='_blank'  class='footerLink'>mailing list</a> to 
          get updates on events and opportunities! Follow us on our Facebook and Instagram page! Join our Discord server!</p>
        </div>
         <br></br>
        <div className='socials'>
          <a id='insta' href='https://www.instagram.com/uw.wic/' target='_blank' rel="noreferrer"><RiInstagramFill/></a>
          <a id='fbook' href='https://www.facebook.com/uwwic' target='_blank' rel="noreferrer"><BsFacebook/></a>
            <a id='discord' href='https://discord.gg/Zp4GVB7ddq' target='_blank' rel="noreferrer"><BsDiscord/></a>
        </div>
        <div className='wicEmail'>
          <a href="mailto:wic-officers@cs.washington.edu" class='footerLink'>wic-officers@cs.washington.edu</a>
        </div>
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Event;


